import React from "react";
import Grid from "@material-ui/core/Grid";
import CustomAlert from "../CustomAlert";
import { isPaperGradesAvailable } from "../../utils";

const Status = ({ accepted, finalGrade }) => {

    return (
        // Ver se é hoje que tem e se pode mostrar
        <Grid item xs={12}>
            {
                !isPaperGradesAvailable() ?
                    <CustomAlert message="Avaliações não disponíveis" />
                    :
                    <>
                        {
                            !accepted ?
                                <CustomAlert message="Trabalho não aceito. Role a página mais abaixo para mais detalhes." />
                                :
                                <CustomAlert severity="info" message={`Trabalho aceito. Média: ${finalGrade}`} />
                        }
                    </>
            }
        </Grid>
    )
}

export default Status
